import { getCompany, getConnector, getTaskAndTaskWorkflow, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createTaxesSyncedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.TAXES_SYNCED,
        ...getUserAndEventTime(),
        ...getTaskAndTaskWorkflow(),
        data: {
            taxes: [
                {
                    type: 'w2',
                    year: '2020-01-01T00:00:00.000Z',
                    totalWages: 50000,
                    form: {
                        _id: '60abeff60836730008616faf',
                        url: '[ATOMIC-GENERATED-PRESIGNED-S3-URL]'
                    },
                    parsedData: {
                        taxYear: 2022,
                        employeeTin: 'XXX-XX-1234',
                        employerTin: '12-3456789',
                        employerNameAddress: {
                            name1: 'Tax Form Issuer, Inc',
                            line1: '12021 Sunset Valley Dr',
                            city: 'Preston',
                            state: 'VA',
                            postalCode: '20191'
                        },
                        controlNumber: '012547 WY/OA7',
                        employeeName: {
                            first: 'Kris',
                            last: 'Public'
                        },
                        employeeAddress: {
                            line1: '1 Main St',
                            city: 'Melrose',
                            state: 'NY',
                            postalCode: '12121'
                        },
                        wages: 44416.74,
                        federalTaxWithheld: 6907.16,
                        socialSecurityWages: 47162.92,
                        socialSecurityTaxWithheld: 2924.1,
                        medicareWages: 47162.92,
                        medicareTaxWithheld: 683.86,
                        socialSecurityTips: 134.25,
                        allocatedTips: 149.75,
                        dependentCareBenefit: 543.25,
                        nonQualifiedPlan: 354.23,
                        codes: [
                            {
                                code: 'C',
                                amount: 301.5
                            },
                            {
                                code: 'D',
                                amount: 2746.18
                            },
                            {
                                code: 'DD',
                                amount: 4781.88
                            }
                        ],
                        other: [
                            {
                                description: 'Housing',
                                amount: 6500
                            },
                            {
                                description: 'Union Dues',
                                amount: 1500
                            }
                        ],
                        stateTaxWithholding: [
                            {
                                stateTaxWithheld: 1726.78,
                                state: 'OH',
                                stateTaxId: 'OH 036-133505158F-01',
                                stateIncome: 44416.74
                            }
                        ],
                        localTaxWithholding: [
                            {
                                localTaxWithheld: 427.62,
                                localityName: 'Kirtland',
                                state: 'OH',
                                localIncome: 44416.74
                            }
                        ]
                    }
                },
                {
                    type: '1099',
                    year: '2020-01-01T00:00:00.000Z',
                    form: {
                        _id: '60abeff60836730008616faf',
                        url: '[ATOMIC-GENERATED-PRESIGNED-S3-URL]'
                    }
                }
            ],
            ...getCompany(),
            ...getConnector(),
            linkedAccount: '5f7212103a40e91f95ba376d'
        }
    };
};
//# sourceMappingURL=taxes-synced.js.map